import { createRoutine } from 'redux-saga-routines'

export const SET = 'MOVIMIENTO_LAYOUT/SET'
export const CONTENT = createRoutine('MOVIMIENTO_LAYOUT/CONTENT')
